import Icon from '../../../components/AppIcon';
import React from 'react';

const HeroSection = () => {
	return (
		<section className='relative bg-gradient-to-r from-[#800020] to-[#800020]/80 pt-20 pb-16'>
			<div className='absolute inset-0 bg-black/20'></div>
			<div className='relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
				<div className='text-center'>
					<div className='inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6'>
						<Icon name='Scale' size={20} color='white' />
						<span className='text-white font-source font-medium'>17 Practice Areas</span>
					</div>
					<h1 className='font-playfair font-bold text-4xl lg:text-6xl text-white mb-6'>
						Comprehensive Legal
						<span className='block text-[#DB954E]'>Excellence</span>
					</h1>
					<p className='text-xl text-white/90 max-w-3xl mx-auto leading-relaxed'>
						From complex corporate transactions to personal legal matters, our specialized attorneys
						deliver exceptional results across every area of law.
					</p>
				</div>
			</div>
		</section>
	);
};

export default HeroSection;
